import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';

import InputField from '../../../shared/form-elements/input';

const Form = ({
	intl,
	formData,
	handleSubmit,
	submitForm
}) => (
	<form className="ui-form affiliate-main__form" onSubmit={handleSubmit(data => submitForm(data))}>
		<div className="ui-form__element">
			<Field
				name="password"
				placeholder={ intl('Enter new password') }
				component={InputField} />
		</div>

		<div className="ui-form__element">
			<button className="ui-btn ui-btn-primary">{ intl('Edit') }</button>
		</div>
	</form>
);

Form.propTypes = {
	intl: PropTypes.func,
	formData: PropTypes.object,
	submitForm: PropTypes.func,
	handleSubmit: PropTypes.func
};

export default reduxForm({
	form: 'affiliateCredentialsForm'
})(Form);


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/components/form/credentials.js